<template>
  <div>

    <b-modal id="edit-pair" centered title="Edit Sample Sets" hide-footer >
      <p style="color: red;" v-show="orderedRecords.length <= 0">You have selected no samples.</p>
      <p style="color: red;" v-show="tooManySamples">You have selected too many samples.</p>
      <p v-show="isAlreadyPair">One of the samples you selected are already a set. Do you wish to separate them?</p>

      <b-button @click="separateSet" variant="warning" v-if="isAlreadyPair && !tooManySamples">Separate Sample Set</b-button>
      <b-button @click="createSet" variant="success" v-if="!isAlreadyPair && orderedRecords.length === 2">Create Sample Set</b-button>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { sampleSet } from "../modules/api";
export default {
  name: "pair-functions",
  methods: {
    async separateSet() {
      const setId = this.orderedRecords[0].setId;

      let res = await sampleSet.delete(setId);

      this.notify({
        variant: res.data.success ? "success" : "warn",
        message: res.data.message
      });
      this.$bvModal.hide("edit-pair");
    },
    async createSet() {
      let res = await sampleSet.create({pairIds: this.currentRecordList});

      this.notify({
        variant: res.data.success ? "success" : "warn",
        message: res.data.message
      });
      this.$bvModal.hide("edit-pair");
    },
    ...mapActions(["notify"])
  },
  computed: {
    isAlreadyPair() {
      
      for (let line of this.orderedRecords) {
        let n = this.orderedRecords.filter(x => x.setId === line.setId);
        if (n.length > 1) {
          return true;
        }
      }
      return false;
    },

    tooManySamples() {
      return this.orderedRecords.length > 2;
    },
    ...mapGetters(["orderedRecords", "currentRecordList"])
  }
};
</script>

<style lang="scss" scoped>

</style>